import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import de from './de.json'
import it from './it.json'
import pt from './pt.json'
import th from './th.json'
import id from './id.json'

export default {
  en,
  es,
  fr,
  de,
  it,
  pt,
  th,
  id,
}



// WEBPACK FOOTER //
// ./scripts/routes/translations/index.js